module.exports = __webpack_public_path__ + "img/OurServiceDigital_pic3.df725d22.png";